import {
  addBusinessDays,
  addMonths,
  addWeeks,
  subBusinessDays,
  subMonths,
  subWeeks,
} from "date-fns";

import FollowUpTime from "@mapmycustomers/shared/enum/activity/FollowUpTime";

type Direction = "add" | "subtract";

type Operation = (date: Date, amount: number) => Date;

const operations: Record<
  Direction,
  {
    businessDays: Operation;
    months: Operation;
    weeks: Operation;
  }
> = {
  add: {
    businessDays: addBusinessDays,
    months: addMonths,
    weeks: addWeeks,
  },
  subtract: {
    businessDays: subBusinessDays,
    months: subMonths,
    weeks: subWeeks,
  },
};

export const getFollowUpDate = (
  startDate: Date,
  followUp: FollowUpTime,
  direction: Direction = "add"
): Date => {
  const op = operations[direction];
  switch (followUp) {
    case FollowUpTime.ONE_DAY:
      return op.businessDays(startDate, 1);
    case FollowUpTime.ONE_MONTH:
      return op.months(startDate, 1);
    case FollowUpTime.ONE_WEEK:
      return op.weeks(startDate, 1);
    case FollowUpTime.THREE_MONTHS:
      return op.months(startDate, 3);
    case FollowUpTime.TWO_DAYS:
      return op.businessDays(startDate, 2);
    case FollowUpTime.TWO_WEEKS:
      return op.weeks(startDate, 2);
    case FollowUpTime.CUSTOM:
    default:
      return startDate;
  }
};
